<template>
  <SimpleDataWithVariation
    :title="title"
    :item-id="itemId"
    :value="value"
    :variation="variation"
    :raw-variation="rawVariation"
    :request-status="requestStatus"
    :comparation-value="comparationValue"
    v-bind="$attrs"
    class="make-a-copy"
    @reload="getData"
  />
</template>

<script>
import { mapActions } from 'vuex';
import { DATA_TYPE } from '@/store/modules/cards/constants';
import SimpleDataWithVariation from './models/SimpleDataWithVariation.vue';
import sacListeningModel from '@/mixins/sac-listening-model';
import { POST_FIELDS, OPERATION, ENTITIES } from '@/services/charts-service';

export default {
  name: 'TotalPostsSharesAndComments',
  components: {
    SimpleDataWithVariation,
  },
  mixins: [
    sacListeningModel,
  ],
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      requestStatus: 'loading',
      showGlobalFilterModal: false,
      filterButton: this.$t('components.OperatorsLogs.filterLabel'),
      value: '',
      variation: '',
      rawVariation: '',
      comparationValue: '',
    };
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getSacListeningWarroomService',
      'getChartsService',
    ]),
    getData(options) {
      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }
      const promisses = [
        this.getSacListeningWarroomService({
          itemId: this.itemId,
          servicePath: 'monitoringOverview',
          filterType: DATA_TYPE.LISTENING,
        }),
        this.getSacListeningWarroomService({
          itemId: this.itemId,
          servicePath: 'monitoringOverview',
          filterType: DATA_TYPE.SAC,
        }),
        this.getChartsService({
          entity: ENTITIES.POSTS,
          itemId: this.itemId,
          filterType: DATA_TYPE.LISTENING,
          method: 'getMetricWithVariation',
          params: {
            fields: [POST_FIELDS.COMMENTS],
            operators: OPERATION.SUM,
          },
        }),
        this.getChartsService({
          entity: ENTITIES.POSTS,
          itemId: this.itemId,
          filterType: DATA_TYPE.LISTENING,
          method: 'getMetricWithVariation',
          params: {
            fields: [POST_FIELDS.SHARES],
            operators: OPERATION.SUM,
          },
        }),
        this.getChartsService({
          entity: ENTITIES.POSTS,
          itemId: this.itemId,
          filterType: DATA_TYPE.SAC,
          method: 'getMetricWithVariation',
          params: {
            fields: [POST_FIELDS.COMMENTS],
            operators: OPERATION.SUM,
          },
        }),
        this.getChartsService({
          entity: ENTITIES.POSTS,
          itemId: this.itemId,
          filterType: DATA_TYPE.SAC,
          method: 'getMetricWithVariation',
          params: {
            fields: [POST_FIELDS.SHARES],
            operators: OPERATION.SUM,
          },
        }),
      ];
      Promise.all(
        promisses
      ).then((responses) => {
        this.value = responses.reduce((acc, response) => acc + (response.collected_mentions || 0), 0);
        this.comparationValue = responses.reduce((acc, response) => acc + (response.previous_collected_mentions || response.collected_previous_mentions || 0), 0);
        this.variation = ((this.value - this.comparationValue) / this.comparationValue) * 100;
        this.rawVariation = ((this.value - this.comparationValue) / this.comparationValue) * 100;
        this.requestStatus = 'success';
      });
    },
  },
};
</script>

<style scoped lang="scss">
</style>
